/**
 * Google Analytics (GA4) helpers
 *
 * Tracking is enabled only when REACT_APP_GA_MEASUREMENT_ID is set in .env.
 * Never send personal data (names, emails, exam content) to GA.
 */

import ReactGA from 'react-ga4';

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;

export const initAnalytics = () => {
  if (!MEASUREMENT_ID || initialized) return;
  // Page views are sent manually on route change (see usePageTracking)
  ReactGA.initialize(MEASUREMENT_ID, { gtagOptions: { send_page_view: false } });
  initialized = true;
};

export const trackPageView = (path) => {
  if (!initialized) return;
  ReactGA.send({ hitType: 'pageview', page: path, title: document.title });
};

export const trackEvent = (name, params = {}) => {
  if (!initialized) return;
  ReactGA.event(name, params);
};
